// import { store } from '@/store'
import { auth } from "@/fireinit.js";
import axios from "axios";

export default (to, from, next) => {
  if (auth.currentUser) {
    if (window.localStorage.hasOwnProperty("currentUserData")) {
      let userData = JSON.parse(window.localStorage.currentUserData);

      if (userData.id != null) {
        if (
          userData.role.includes("Admin") ||
          userData.role.includes("Business") ||
          userData.role.includes("ImpactBusiness") ||
          userData.role.includes("GoodCause")
        ) {
          next();
        } else {
          next("/");
        }
      } else {
        next("/");
      }
    } else {
      axios
        .get(`https://prod.legacy.api.oatas.co/upstream/user/CurrentUserData`, {
          headers: {
            Authorization: `Bearer ${auth.currentUser._lat}`,
          },
        })
        .then((response) => {
          if (
            response.data.role.includes("Admin") ||
            response.data.role.includes("Business") ||
            response.data.role.includes("ImpactBusiness") ||
            userData.role.includes("GoodCause")
          ) {
            localStorage.setItem(
              "currentUserData",
              JSON.stringify(response.data)
            );

            next();
          } else {
            next("/");
          }
        });
    }
  } else {
    next("/");
  }
};
